import request from '@/utils/ai-train-request'

// AI训战 - 难度档名配置（ai_difficulty_tier：percent_from/percent_to/display_name/sort，初始 5 行）
// 验收用例 §6-11：后台改名 H5 刷新即生效，不发版 —— 前端因此不允许写死档名
const apiPath = '/admin/difficulty-tier'

const aiTrainTierApi = {
  fetchList() {
    return request({ url: apiPath, method: 'get' })
  },
  update(data) {
    return request({ url: apiPath, method: 'put', data })
  }
}

export default aiTrainTierApi
